"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _SidebarAbstractCard = _interopRequireDefault(require("crm_ui/sidebar/card/SidebarAbstractCard"));

var displayName = 'SidebarCard';

var SidebarCard = function SidebarCard(props) {
  var style = props.style,
      transferableProps = (0, _objectWithoutProperties2.default)(props, ["style"]);
  return _react.default.createElement("section", {
    style: style
  }, _react.default.createElement(_SidebarAbstractCard.default, transferableProps));
};

SidebarCard.displayName = displayName;
var _default = SidebarCard;
exports.default = _default;
module.exports = exports.default;